/* eslint-disable complexity */ import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { ProductImage } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductImage";
import { getIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { isLoggedInRetailer, isLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useMarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { isFastly } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { TelemetryManager } from "@faire/web--source/common/opentelemetry/TelemetryManager";
import { faireBaseUrl } from "@faire/web--source/common/routes/faireBaseUrl";
import { isPrerender } from "@faire/web--source/common/user-agent/isPrerender";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackEventsUntrackedproducttileView } from "@faire/web-api--source/events/events/view/untrackedproducttile";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
import { IProduct as IProductNotLean } from "@faire/web-api--source/indigofair/data/IProduct";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { observer } from "mobx-react";
import React, { Suspense, useMemo, useRef } from "react";
import styled, { css } from "styled-components";
import { RoundedPlusButton } from "@faire/retailer-visitor-shared/components/Button/RoundedPlusButton";
import { selectBadge } from "@faire/retailer-visitor-shared/components/ProductBadge/badgeUtils";
import { QuickAdd } from "@faire/retailer-visitor-shared/components/QuickAdd/index";
import { RoundQuantityPickerWrapper } from "@faire/retailer-visitor-shared/components/QuickAdd/EncapsulatedQuickAdd";
import { LazyEncapsulatedQuickAdd } from "@faire/retailer-visitor-shared/components/QuickAdd/LazyEncapsulatedQuickAdd";
import { RoundNotifyMeButton } from "@faire/retailer-visitor-shared/components/RoundNotifyMeButton/index";
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { withConfigurationConsumer } from "@faire/retailer-visitor-shared/features/MarketplaceItems/__internal__/configurableProductTileUtils";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ProductTileOverlay } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileOverlay/ProductTileOverlay";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useContainerRef } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/useContainerRef";
import { RetailInfo } from "@faire/retailer-visitor-shared/features/MarketplaceItems/RetailInfo";
import { ImageContainer, NotifyMeWrapper, ProductError } from "@faire/retailer-visitor-shared/features/MarketplaceItems/styled";
import { TopBadges } from "@faire/retailer-visitor-shared/features/MarketplaceItems/TopBadges";
import { SaveToBoard } from "@faire/retailer-visitor-shared/features/RetailerBoards/Components/SaveToBoard";
import { SaveToBoardContext, SaveToBoardProvider } from "@faire/retailer-visitor-shared/features/RetailerBoards/Context";
import { useCartItems } from "@faire/retailer-visitor-shared/hooks/cart/useCartItems";
import { useProductTileClickImpressions } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressions";
import { useProductTileViewImpression } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileViewImpression";
import { canAddToCart } from "@faire/retailer-visitor-shared/lib/canAddToCart";
import { filterInvalidImages } from "@faire/retailer-visitor-shared/lib/filterInvalidImages";
import { ProductPagePaths } from "@faire/retailer-visitor-shared/paths/ProductPage";
import { assignSettingOnEvent } from "@faire/retailer-visitor-shared/settings/assignSettingOnEvent";
import { ProductTileRoundQuantityOptionPicker } from "@faire/retailer-visitor-shared/components/QuickAdd/ProductTileRoundQuantityOptionPicker";
import { preloadNavigationToPDP } from "@faire/retailer-visitor-shared/views/product/preload/preloadNavigationToPDP";
import { getAltTag } from "@faire/retailer-visitor-shared/features/Marketplace/utils";
import { useCartProductAddOptions } from "@faire/retailer-visitor-shared/features/ProductAdd/useCartProductAddOptions";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { productTileOverlayProductTileAdaptor } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileOverlay/productTileOverlayUtils";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { productClickForSearchPageParametersILeanProductTileAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";
var PADDING_AROUND_BUTTON_WIDTH = 16;
var DEFAULT_BUTTON_WIDTH_FOR_MULTI_OPTION_PICKER = 32;
var ProductTileBase = function(props) {
    var _productTile_product, _productTile_product1, _productTile_product2, _productTile_product3, _productTile_product4, _props_productTile, _props_productTile_product, _props_productTile1, _productTile_product5, _props_productTile_quick_add_quick_add_option, _props_productTile_quick_add, _props_productTile2, _productTile_badge_list, _productTile_product6, _productTile_product7, _productTile_product8, _props_productTile_product1;
    var productTile = props.productTile, altTag = props.altTag, updateCartFn = props.updateCartFn, recordProductTileImpressionForAds = props.recordProductTileImpressionForAds, hideSaveToBoard = props.hideSaveToBoard, allowLinkInterception = props.allowLinkInterception;
    var _TelemetryManager_get_startManagedSpan;
    var productTileSpan = TelemetryManager.get().getManagedSpan((_TelemetryManager_get_startManagedSpan = TelemetryManager.get().startManagedSpan("ProductTile", {
        productToken: productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token
    }, undefined)) !== null && _TelemetryManager_get_startManagedSpan !== void 0 ? _TelemetryManager_get_startManagedSpan : "");
    var imageLoadSpan = TelemetryManager.get().startSpan("ProductTileImage", undefined, productTileSpan !== null && productTileSpan !== void 0 ? productTileSpan : undefined);
    React.useEffect(function() {
        if (productTileSpan) {
            // End the span when the component finishes rendering
            TelemetryManager.get().endSpan(productTileSpan);
        }
    }, [
        productTileSpan
    ]);
    var strictLocalize = useStrictLocalization().strictLocalize;
    var canAdd = props.isInvoice || canAddToCart();
    var imageContainerRef = useRef(null);
    var trackProductTileProps = useProductTileViewImpression({
        productToken: productTile === null || productTile === void 0 ? void 0 : (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.token,
        promotedBy: productTile === null || productTile === void 0 ? void 0 : (_productTile_product2 = productTile.product) === null || _productTile_product2 === void 0 ? void 0 : _productTile_product2.promoted_by,
        impressionId: productTile === null || productTile === void 0 ? void 0 : (_productTile_product3 = productTile.product) === null || _productTile_product3 === void 0 ? void 0 : _productTile_product3.impression_id,
        turnOffTracking: !recordProductTileImpressionForAds
    });
    var imageRef = useContainerRef(imageContainerRef);
    var buttonMaxWidth = useMemo(function() {
        return imageRef === null || imageRef === void 0 ? void 0 : imageRef.clientWidth;
    }, [
        imageRef
    ]);
    var leanProductTile = !productTile ? undefined : productClickForSearchPageParametersILeanProductTileAdapter(ILeanProductTile.build(_object_spread_props(_object_spread({}, productTile), {
        product: !productTile.product ? undefined : ILeanProductTile.ILeanProduct.build(_object_spread({}, productTile.product))
    })));
    var _useProductTileClickImpressions = useProductTileClickImpressions(leanProductTile, undefined, recordProductTileImpressionForAds), recordProductTileClickEvent = _useProductTileClickImpressions.recordProductTileClickEvent, recordProductBadgeViewEvent = _useProductTileClickImpressions.recordProductBadgeViewEvent, recordChooseOptionClickEvent = _useProductTileClickImpressions.recordChooseOptionClickEvent, recordQuickAddSubmitEvent = _useProductTileClickImpressions.recordQuickAddSubmitEvent, recordQuickAddButtonClickEvent = _useProductTileClickImpressions.recordQuickAddButtonClickEvent, recordSaveToBoardSubmitEvent = _useProductTileClickImpressions.recordSaveToBoardSubmitEvent, recordHeartClickedEvent = _useProductTileClickImpressions.recordHeartClickedEvent, recordChooseOptionQuantityUpdateSubmitEvent = _useProductTileClickImpressions.recordChooseOptionQuantityUpdateSubmitEvent, recordRemoveFromBoardSubmitEvent = _useProductTileClickImpressions.recordRemoveFromBoardSubmitEvent, recordProductTileMiddleClickEvent = _useProductTileClickImpressions.recordProductTileMiddleClickEvent, recordProductTileRightClickEvent = _useProductTileClickImpressions.recordProductTileRightClickEvent;
    var _useQuery = useQuery({
        queryKey: [
            "validate-image-result",
            productTile === null || productTile === void 0 ? void 0 : productTile.best_image
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            var image;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        image = productTile === null || productTile === void 0 ? void 0 : productTile.best_image;
                        if (!((image === null || image === void 0 ? void 0 : image.url) && !isFastly(image.url))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            filterInvalidImages([
                                image
                            ])
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 2:
                        return [
                            2,
                            []
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })
    }), validateImageLoading = _useQuery.isPending, validateImageError = _useQuery.isError, validateImageData = _useQuery.data;
    var location = useZustandLocation(function(param) {
        var search = param.search, pathname = param.pathname;
        return {
            search: search,
            pathname: pathname
        };
    });
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var queryClient = useQueryClient();
    React.useEffect(function() {
        if (!recordProductTileImpressionForAds) {
            var _productTile_product;
            var _productTile_product_token;
            trackEventsUntrackedproducttileView(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", (_productTile_product_token = productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token) !== null && _productTile_product_token !== void 0 ? _productTile_product_token : "", location.pathname + location.search);
        }
    }, [
        recordProductTileImpressionForAds,
        productTile === null || productTile === void 0 ? void 0 : (_productTile_product4 = productTile.product) === null || _productTile_product4 === void 0 ? void 0 : _productTile_product4.token,
        retailerToken,
        location.pathname,
        location.search
    ]);
    var getProductTileQuantityInCart = useCartItems().getProductTileQuantityInCart;
    var cartProductAddOptions = useCartProductAddOptions();
    var _props_productAddOptions;
    var productAddOptions = (_props_productAddOptions = props.productAddOptions) !== null && _props_productAddOptions !== void 0 ? _props_productAddOptions : cartProductAddOptions;
    var handleClick = useEffectEvent(function() {
        var _productTile_product;
        recordProductTileClickEvent();
        if (productTile) {
            var _productTile_product1;
            preloadNavigationToPDP(queryClient, {
                productToken: (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.token,
                bestImage: productTile.best_image,
                images: productTile.images,
                showVerticalImagery: props.showVerticalImagery
            });
        }
        if (productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token) {
            var _props_onProductClick;
            (_props_onProductClick = props.onProductClick) === null || _props_onProductClick === void 0 ? void 0 : _props_onProductClick.call(props, productTile.product.token);
        }
    });
    var handleOnAuxClick = useEffectEvent(function(event) {
        if (event.button === 1) {
            recordProductTileMiddleClickEvent();
        } else if (event.button === 2) {
            recordProductTileRightClickEvent();
        }
    });
    var handleChooseOption = function() {
        var _props_onChooseOption;
        recordChooseOptionClickEvent();
        (_props_onChooseOption = props.onChooseOption) === null || _props_onChooseOption === void 0 ? void 0 : _props_onChooseOption.call(props);
    };
    var handleQuickAdd = function(newQuantity) {
        var _props_onQuickAddClick;
        recordQuickAddButtonClickEvent();
        (_props_onQuickAddClick = props.onQuickAddClick) === null || _props_onQuickAddClick === void 0 ? void 0 : _props_onQuickAddClick.call(props, newQuantity);
    };
    var primaryImage = useMemo(function() {
        var _props_productTile;
        var image = (_props_productTile = props.productTile) === null || _props_productTile === void 0 ? void 0 : _props_productTile.best_image;
        if ((image === null || image === void 0 ? void 0 : image.url) && isFastly(image.url)) {
            return image;
        } else if (validateImageLoading || validateImageError || !validateImageData) {
            return PLACEHOLDER_IMAGE;
        } else {
            var _validateImageData_;
            return (_validateImageData_ = validateImageData[0]) !== null && _validateImageData_ !== void 0 ? _validateImageData_ : PLACEHOLDER_IMAGE;
        }
    }, [
        validateImageError,
        validateImageLoading,
        (_props_productTile = props.productTile) === null || _props_productTile === void 0 ? void 0 : _props_productTile.best_image,
        validateImageData
    ]);
    var productName = (_props_productTile1 = props.productTile) === null || _props_productTile1 === void 0 ? void 0 : (_props_productTile_product = _props_productTile1.product) === null || _props_productTile_product === void 0 ? void 0 : _props_productTile_product.name;
    var isSalesPaused = (productTile === null || productTile === void 0 ? void 0 : (_productTile_product5 = productTile.product) === null || _productTile_product5 === void 0 ? void 0 : _productTile_product5.state) === IProductNotLean.State.SALES_PAUSED;
    var _props_productTile_quick_add_quick_add_option_option_available_units;
    var availableUnits = (_props_productTile_quick_add_quick_add_option_option_available_units = (_props_productTile2 = props.productTile) === null || _props_productTile2 === void 0 ? void 0 : (_props_productTile_quick_add = _props_productTile2.quick_add) === null || _props_productTile_quick_add === void 0 ? void 0 : (_props_productTile_quick_add_quick_add_option = _props_productTile_quick_add.quick_add_option) === null || _props_productTile_quick_add_quick_add_option === void 0 ? void 0 : _props_productTile_quick_add_quick_add_option.option_available_units) !== null && _props_productTile_quick_add_quick_add_option_option_available_units !== void 0 ? _props_productTile_quick_add_quick_add_option_option_available_units : Number.POSITIVE_INFINITY;
    var canQuickAddProduct = (canAdd || getIsBrandPreview()) && !isSalesPaused && availableUnits !== 0;
    var canSaveToBoard = isLoggedInRetailer() && !props.hideDetails && !hideSaveToBoard;
    var saveToBoardContext = React.useContext(SaveToBoardContext);
    var topBadge = useMemo(function() {
        var _productTile_badge_list;
        var _productTile_badge_list_badges;
        var productBadges = (_productTile_badge_list_badges = productTile === null || productTile === void 0 ? void 0 : (_productTile_badge_list = productTile.badge_list) === null || _productTile_badge_list === void 0 ? void 0 : _productTile_badge_list.badges) !== null && _productTile_badge_list_badges !== void 0 ? _productTile_badge_list_badges : [];
        return selectBadge(productBadges, "TOP");
    }, [
        productTile === null || productTile === void 0 ? void 0 : (_productTile_badge_list = productTile.badge_list) === null || _productTile_badge_list === void 0 ? void 0 : _productTile_badge_list.badges
    ]);
    var _useMemo = useMemo(function() {
        var _productTile_product, _productTile_product1, _props_generateProductLinkProps;
        var productToken = productTile === null || productTile === void 0 ? void 0 : (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token;
        if (!productToken) {
            return {
                productUrl: faireBaseUrl()
            };
        }
        // For SEO discoverability, expose "real" product page links instead of a signup brand page link for bot.
        if (isPrerender()) {
            return {
                productUrl: ProductPagePaths.index(productToken)
            };
        }
        var selectedProductOptionToken = productTile === null || productTile === void 0 ? void 0 : productTile.selected_product_option_token;
        var brandToken = productTile === null || productTile === void 0 ? void 0 : (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.brand_token;
        var _props_generateProductLinkProps1;
        return (_props_generateProductLinkProps1 = (_props_generateProductLinkProps = props.generateProductLinkProps) === null || _props_generateProductLinkProps === void 0 ? void 0 : _props_generateProductLinkProps.call(props, productToken, location, brandToken, selectedProductOptionToken)) !== null && _props_generateProductLinkProps1 !== void 0 ? _props_generateProductLinkProps1 : {
            productUrl: ProductPagePaths.index(productToken, {
                productOptionToken: selectedProductOptionToken
            })
        };
    }, [
        productTile === null || productTile === void 0 ? void 0 : (_productTile_product6 = productTile.product) === null || _productTile_product6 === void 0 ? void 0 : _productTile_product6.token,
        productTile === null || productTile === void 0 ? void 0 : (_productTile_product7 = productTile.product) === null || _productTile_product7 === void 0 ? void 0 : _productTile_product7.brand_token,
        productTile === null || productTile === void 0 ? void 0 : productTile.selected_product_option_token,
        props,
        location
    ]), productUrl = _useMemo.productUrl, replace = _useMemo.replace;
    var marketStore = useMarketStore([
        "isLive"
    ]);
    var renderExtraContent = function() {
        var _props_configuration, _productTile_product, _productTile_quick_add_quick_add_option, _productTile_quick_add;
        var extraElements = [];
        if (!(productTile === null || productTile === void 0 ? void 0 : productTile.product)) {
            return null;
        }
        var hideMarketBadge = ((_props_configuration = props.configuration) === null || _props_configuration === void 0 ? void 0 : _props_configuration.disableEventBadge) && marketStore.isLive;
        var showEventBadge = !hideMarketBadge && (productTile === null || productTile === void 0 ? void 0 : productTile.is_highlighted_product_for_promotional_event);
        var _productTile_product_token;
        var cartQuantity = getProductTileQuantityInCart((_productTile_product_token = (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token) !== null && _productTile_product_token !== void 0 ? _productTile_product_token : "");
        var quickAddProductOptionToken = productTile === null || productTile === void 0 ? void 0 : (_productTile_quick_add = productTile.quick_add) === null || _productTile_quick_add === void 0 ? void 0 : (_productTile_quick_add_quick_add_option = _productTile_quick_add.quick_add_option) === null || _productTile_quick_add_quick_add_option === void 0 ? void 0 : _productTile_quick_add_quick_add_option.option_token;
        var _saveToBoardContext_trackOrigin;
        extraElements.push(/*#__PURE__*/ _jsx(TopBadges, {
            tileBadge: topBadge,
            onTopLeftBadgeVisible: recordProductBadgeViewEvent,
            favoriteButton: canSaveToBoard ? /*#__PURE__*/ _jsx(SaveToBoardProvider, {
                value: {
                    trackOrigin: (_saveToBoardContext_trackOrigin = saveToBoardContext.trackOrigin) !== null && _saveToBoardContext_trackOrigin !== void 0 ? _saveToBoardContext_trackOrigin : "brand"
                },
                children: /*#__PURE__*/ _jsx(StyledSaveToBoard, {
                    "data-test-id": "favorite-button",
                    productToken: productTile.product.token,
                    productImage: productTile.best_image,
                    boardTokens: productTile.product.board_tokens,
                    brandToken: productTile.product.brand_token,
                    onHeartClicked: recordHeartClickedEvent,
                    onSaveToBoard: recordSaveToBoardSubmitEvent,
                    onRemoveFromBoard: recordRemoveFromBoardSubmitEvent
                }, "".concat(productTile.product.token, "-favorite"))
            }) : null,
            showEventBadge: showEventBadge,
            hideDetails: props.hideDetails
        }, "top-badges"));
        if (props.hideAddToCartAndNotifyMe) {
            return extraElements.length > 0 ? extraElements : null;
        }
        if (props.isInvoice || canQuickAddProduct && (productTile === null || productTile === void 0 ? void 0 : productTile.quick_add)) {
            if (props.isInvoice || props.showEncapsulatedQuickAdd) {
                var _productTile_product1, _productTile_product2, _productTile_product3, _productTile_product4;
                extraElements.push(/*#__PURE__*/ _jsx(Suspense, {
                    fallback: null,
                    children: /*#__PURE__*/ _jsx(LazyEncapsulatedQuickAdd, {
                        productToken: (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.token,
                        quickAdd: productTile.quick_add,
                        brandToken: (_productTile_product2 = productTile.product) === null || _productTile_product2 === void 0 ? void 0 : _productTile_product2.brand_token,
                        imageContainerRef: imageContainerRef,
                        updateItems: updateCartFn,
                        onQuickAddClick: handleQuickAdd,
                        onQuickAddSubmit: recordQuickAddSubmitEvent,
                        onChooseOption: handleChooseOption,
                        onChooseOptionQuantityUpdate: recordChooseOptionQuantityUpdateSubmitEvent
                    }, "".concat((_productTile_product3 = productTile.product) === null || _productTile_product3 === void 0 ? void 0 : _productTile_product3.token, "-encapsulated-quick-add"))
                }, "".concat((_productTile_product4 = productTile.product) === null || _productTile_product4 === void 0 ? void 0 : _productTile_product4.token, "-suspense")));
            } else {
                if (props.showPlusButton) {
                    if (props.renderCollapsableQuickAddButtonProps) {
                        var _productTile_product5;
                        extraElements.push(/*#__PURE__*/ _jsx(RoundQuantityPickerWrapper, {
                            onClick: function(e) {
                                e.preventDefault();
                            },
                            "data-test-id": "quick-add-marketplace-product",
                            children: /*#__PURE__*/ _jsx(ProductTileRoundQuantityOptionPicker, _object_spread_props(_object_spread({}, props.renderCollapsableQuickAddButtonProps), {
                                value: cartQuantity,
                                maxWidth: // either use container width or use the picker width
                                (buttonMaxWidth !== null && buttonMaxWidth !== void 0 ? buttonMaxWidth : DEFAULT_BUTTON_WIDTH_FOR_MULTI_OPTION_PICKER) - PADDING_AROUND_BUTTON_WIDTH
                            }))
                        }, "".concat((_productTile_product5 = productTile.product) === null || _productTile_product5 === void 0 ? void 0 : _productTile_product5.token, "-round-quantity-picker")));
                    } else {
                        var _productTile_product6;
                        extraElements.push(/*#__PURE__*/ _jsx(PlusButton, {
                            "data-test-id": "quick-add-marketplace-product",
                            onClick: function(e) {
                                var _props_onQuickAddClick;
                                e.preventDefault();
                                (_props_onQuickAddClick = props.onQuickAddClick) === null || _props_onQuickAddClick === void 0 ? void 0 : _props_onQuickAddClick.call(props);
                            }
                        }, "".concat((_productTile_product6 = productTile.product) === null || _productTile_product6 === void 0 ? void 0 : _productTile_product6.token, "-plus-btn")));
                    }
                } else if (productTile === null || productTile === void 0 ? void 0 : productTile.quick_add) {
                    var _productTile_product7;
                    extraElements.push(/*#__PURE__*/ _jsx(DesktopQuickAdd, {
                        productToken: productTile.product.token,
                        brandToken: productTile.product.brand_token,
                        quickAddData: productTile.quick_add,
                        onQuickAddOption: handleQuickAdd,
                        onChooseOption: handleChooseOption,
                        forceShowModal: !!productTile.product.per_style_min_order_quantity,
                        productAddOptions: productAddOptions,
                        style: {
                            bottom: "10px"
                        },
                        isHighlightedProductForPromotionalEvent: productTile.is_highlighted_product_for_promotional_event,
                        updateCartFn: updateCartFn
                    }, "".concat((_productTile_product7 = productTile.product) === null || _productTile_product7 === void 0 ? void 0 : _productTile_product7.token, "-quick-add")));
                }
            }
        } else if (isSalesPaused && quickAddProductOptionToken !== undefined && isLoggedInRetailer()) {
            var _productTile_product8;
            extraElements.push(/*#__PURE__*/ _jsx(NotifyMeWrapper, {
                onClick: function(e) {
                    return e.preventDefault();
                },
                children: /*#__PURE__*/ _jsx(RoundNotifyMeButton, {
                    productOptionToken: quickAddProductOptionToken,
                    isSubscriedToBackInStock: props.isSubscriedToBackInStock,
                    deleteBackInStockNotification: props.deleteBackInStockNotification
                })
            }, "".concat((_productTile_product8 = productTile.product) === null || _productTile_product8 === void 0 ? void 0 : _productTile_product8.token, "-round-notify-me-picker")));
        }
        return extraElements.length > 0 ? extraElements : null;
    };
    var userStore = useUserStore([
        "isEmployee"
    ]);
    var renderErrorPlaceholder = function() {
        if (userStore.isEmployee) {
            var _props_productTile_product, _props_productTile;
            return /*#__PURE__*/ _jsxs(ProductError, {
                children: [
                    "Missing options or image or name for product",
                    " ",
                    (_props_productTile = props.productTile) === null || _props_productTile === void 0 ? void 0 : (_props_productTile_product = _props_productTile.product) === null || _props_productTile_product === void 0 ? void 0 : _props_productTile_product.token
                ]
            });
        }
        return null;
    };
    var settingsAssignmentRef = useDoActionWhenVisible(function() {
        productTile === null || productTile === void 0 ? void 0 : productTile.settings_to_assign_on_view.forEach(function(setting) {
            assignSettingOnEvent(setting);
        });
    });
    if (props.productTile === undefined || !primaryImage || !productName) {
        return renderErrorPlaceholder();
    }
    var ProductLink = allowLinkInterception ? AnchorProductLink : RegularProductLink;
    var productLinkProps = _object_spread({
        to: productUrl,
        replace: replace
    }, allowLinkInterception ? {
        href: productUrl
    } : {});
    var _props_datatestid;
    //TODO: @z27fangFaire change all product image section to use `ProductImage` instead of a carousel.
    return(// trackProductTileProps should ALWAYS wrap the outermost div of the product tile
    /*#__PURE__*/ _jsx(Container, _object_spread_props(_object_spread({}, trackProductTileProps), {
        onAuxClick: handleOnAuxClick,
        ref: function(element) {
            var _trackProductTileProps_ref;
            trackProductTileProps === null || trackProductTileProps === void 0 ? void 0 : (_trackProductTileProps_ref = trackProductTileProps.ref) === null || _trackProductTileProps_ref === void 0 ? void 0 : _trackProductTileProps_ref.call(trackProductTileProps, element);
            settingsAssignmentRef(element);
        },
        children: /*#__PURE__*/ _jsxs(ProductLink, _object_spread_props(_object_spread({
            onClick: handleClick,
            className: props.className,
            "data-test-id": (_props_datatestid = props["data-test-id"]) !== null && _props_datatestid !== void 0 ? _props_datatestid : "product-tile",
            target: props.newTab ? "_blank" : undefined
        }, productLinkProps), {
            children: [
                /*#__PURE__*/ _jsxs(ImageContainer, {
                    ref: imageContainerRef,
                    children: [
                        /*#__PURE__*/ _jsx(ProductImage, {
                            image: primaryImage,
                            imageDimension: props.imageDimension,
                            showVerticalImagery: props.showVerticalImagery,
                            alt: altTag !== null && altTag !== void 0 ? altTag : getAltTag({
                                productName: productName,
                                pageType: PAGE_TYPE.BRAND,
                                brandName: props.brandName
                            }, strictLocalize),
                            shouldIncrementallyLoadImages: true,
                            onLoad: function() {
                                return TelemetryManager.get().endSpan(imageLoadSpan);
                            }
                        }),
                        /*#__PURE__*/ _jsx(ProductTileOverlay, {
                            // TODO this probably needs to be memoized
                            data: productTileOverlayProductTileAdaptor(ILeanProductTile.build({
                                product: ILeanProductTile.ILeanProduct.build({
                                    state: productTile === null || productTile === void 0 ? void 0 : (_productTile_product8 = productTile.product) === null || _productTile_product8 === void 0 ? void 0 : _productTile_product8.state
                                })
                            }))
                        }),
                        renderExtraContent()
                    ]
                }),
                props.hideInfo ? null : /*#__PURE__*/ _jsx(RetailInfo, {
                    productTile: props.productTile,
                    isLoggedInOrBrandPreview: isLoggedInRetailerOrBrandPreview(),
                    isSalesPaused: isSalesPaused
                })
            ]
        }), "".concat((_props_productTile_product1 = props.productTile.product) === null || _props_productTile_product1 === void 0 ? void 0 : _props_productTile_product1.token, "-product-tile"))
    })));
};
export var ProductTile = withConfigurationConsumer(observer(ProductTileBase));
ProductTile.displayName = "ProductTile";
var PLACEHOLDER_IMAGE = IImage.build({
    token: "p_placeholder",
    url: "https://cdn.faire.com/fastly/3f21a8e5b96b2c091abc81901eddfd258b8a5db4f3abcf99ecefb5dbde7d54b6.png"
});
var DesktopQuickAdd = styled(QuickAdd).withConfig({
    componentId: "sc-418617ac-0"
})([
    "&&&{display:none;}"
]);
var PlusButton = styled(RoundedPlusButton).withConfig({
    componentId: "sc-418617ac-1"
})([
    "position:absolute;bottom:",
    ";right:",
    ";z-index:3;"
], getSpacing("1x"), getSpacing("1x"));
var productLinkStyles = css([
    "flex:1;display:flex;flex-direction:column;position:relative;",
    "{&:hover{",
    " ",
    " ",
    "{display:flex;}}}"
], responsiveMediaQueries.desktopAndAbove, DesktopQuickAdd, DesktopQuickAdd, DesktopQuickAdd);
var RegularProductLink = styled(Link).withConfig({
    componentId: "sc-418617ac-2"
})([
    "",
    ""
], productLinkStyles);
// This is used so mobile can intercept the navigation event
// eslint-disable-next-line @faire/no-raw-anchor-tag
var AnchorProductLink = styled.a.withConfig({
    componentId: "sc-418617ac-3"
})([
    "",
    ""
], productLinkStyles);
var StyledSaveToBoard = styled(SaveToBoard).withConfig({
    componentId: "sc-418617ac-4"
})([
    "position:relative;"
]);
var Container = styled(Column).withConfig({
    componentId: "sc-418617ac-5"
})([
    "position:relative;"
]);
